import { render, staticRenderFns } from "./CrashBetElement.vue?vue&type=template&id=e2a65ca2&scoped=true"
import script from "./CrashBetElement.vue?vue&type=script&lang=js"
export * from "./CrashBetElement.vue?vue&type=script&lang=js"
import style0 from "./CrashBetElement.vue?vue&type=style&index=0&id=e2a65ca2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2a65ca2",
  null
  
)

export default component.exports